import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { ProposalFile } from './proposal-file';
import { ProposalLineItem } from './proposal-line-item';
import { ProposalRequestVendor } from './proposal-request-vendor';

export class RequestJob extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ProposalProperties: (
    | {
        property: keyof RequestJob;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof RequestJob;
        type: 'alias';
      }
    | {
        property: keyof RequestJob;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'requestedById', type: 'column', dataType: 'number' },
    { property: 'RequestJobTitleId', type: 'column', dataType: 'number' },
    { property: 'status', type: 'column', dataType: 'string' },
    { property: 'finishDate', type: 'column', dataType: 'date' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    RequestJob.ProposalProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        RequestJob.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        RequestJob.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        RequestJob.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(ProposalObject: Partial<RequestJob>) {
    super();

    RequestJob.ProposalProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = ProposalObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  requestedById?: number | null;
  RequestJobTitleId?: number;
  status?: 'PENDING' | 'PROCESSING' | 'COMPLETE' | 'REJECTED';
  finishDate?: Date;
  createdAt?: Date;
  updatedAt?: Date;
}
